import React, {Component} from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as profileActions from "../../actions/profileActions";
import Spinner from "../Shared/Spinner";

class Auth extends Component{
    constructor(props) {
        super(props);
        document.body.className += " login-container";
        let { profile, profileActions } = this.props;
        if (profile.isAuth) {
            profileActions.ProfileLogout();
        }
    }
    componentWillUnmount() {
        document.body.classList.remove("login-container");
    }
    componentDidUpdate() {
        let { profile } = this.props;

        if (profile.isAuth) {
            this.props.history.push(profile.backUrl);
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        let th = this;
        this.props.profileActions.ProfileLogin(this.email.value, this.password.value);

    }

    render(){
        let { profile } = this.props;
        return(
            <div className="page-container">
                <div className="page-content">
                    <div className="content-wrapper">
                        <form className="form-horizontal" onSubmit={(e) => this.handleSubmit(e)}>
                            <div className="panel panel-body login-form">
                                <div className="text-center">
                                    <div className="icon-object border-slate-300 text-slate-300"><i className="icon-reading"></i></div>
                                    <h5 className="content-group">Вход в аккаунт <small className="display-block">Введите ваши данные ниже</small></h5>
                                </div>

                                <div className="form-group has-feedback has-feedback-left">
                                    <input className="form-control error" placeholder="Email" ref={(input) => {
                                        this.email = input;
                                    }} />
                                    <div className="form-control-feedback">
                                        <i className="icon-user text-muted"></i>
                                    </div>
                                </div>

                                <div className="form-group has-feedback has-feedback-left">
                                    <input type="password" className="form-control" placeholder="Пароль" ref={(input) => {
                                        this.password = input;
                                    }} />
                                    <div className="form-control-feedback">
                                        <i className="icon-lock2 text-muted"></i>
                                    </div>
                                </div>

                                <div className="form-group">
                                    {
                                        profile.error ?
                                            <div className="text-danger-300 text-center">{profile.errorText}</div>
                                            : null
                                    }
                                    <button type="submit" className="btn btn-primary btn-block" >
                                        {
                                            profile.fetching ?
                                                <Spinner />
                                                : <span>Войти</span>
                                        }
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        profile: state.profile
    }
}

function mapDispatchToProps(dispath) {
    return {
        profileActions: bindActionCreators(profileActions, dispath)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Auth);


// WEBPACK FOOTER //
// ./src/components/Auth/index.jsx